import { useDispatch } from "react-redux";
import { Button } from "@material-ui/core";
import Chat from "../../pages/trading/chat";
import TradeTable from "../../pages/trading/result";
import React, {useState, useEffect } from "react";
import CreatingInvoice from "./create_invoice";
import QRCodeView from "./render_qr";
import WithdrawView from "./withdraw_sats";
var exist_ = false;
var ready_cnt = 0;

const CreateGift = () => {
  const [lnurlwInvoice, setLnurlwInvoice] = useState(""); // 사용자가 보내고자하는 invoice (user -> gift server)

  const [invoice, setInvoice] = useState(""); // 사용자가 보내고자하는 invoice (user -> gift server)
  const [hash, setHash] = useState(""); // invoice 상태 체크하기 위한 hash
  const [amount, setAmount] = useState(""); // 사용자가 전송하고자 하는 사토시 양
  const [number, setNumber] = useState(""); // 사용자가 전송하고자 하는 사토시 양
  const [payStatus, setPayStatus] = useState(false); // 사용자가 입금했는지 여부
  const live_version = true;

  const heroContent = {
    meta: ["# Gift", "# QR코드"],
    title: "비트코인 기프트콘",
    descriptions: `비트코인 선물하기 QR코드를 만듭니다.`,
    description2: "powered by lightning network ⚡️",
  };

  useEffect(() => {
    initializeComponent();
  }, []);


  // eslint-disable-next-line react-hooks/exhaustive-deps
  const pollApi = async () => {
    try {
      const response = await fetch(`/api/lnbits/check_status?hash=${hash}`);
      const data = await response.json();
      console.log('poll', data);
      if(data.result){
        if(data.result == true && data.status){
          // call check paid status api
          if(!exist_) {
            exist_ = true;
            const r_ = await query_check_state(hash);            
            console.log('query check state', r_, data.status);
            if(r_.status && r_.numbers ==1 ) setLnurlwInvoice(r_.lnurlw)
            setPayStatus(data.status);
        }
        }
        // data.status가 true이면.. 성공이라고 띄우기
      }
    } catch (error) {
    }
  };

  // invoice check
  useEffect(() => {
    if (invoice !== '' && payStatus == false) {
      const interval = setInterval(pollApi, 1000); // poll every 5 seconds
      return () => clearInterval(interval);
    }
  }, [payStatus, invoice]);


  function initializeComponent() {
    // Code to run on component mount goes here
    ready_cnt++;
    if(ready_cnt == 1) {
    }
  }


  const query_check_state = async (hash) =>{
    const url = live_version? 'https://us-central1-kogods.cloudfunctions.net/check_invoice_state':'http://127.0.0.1:5001/kogods/us-central1/check_invoice_state'


    const requestBody = {hash_invoice:hash}
    try {
      var response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers': 'Content-Type'
        }
      })
      return response.json();
    } catch (error) {
      return {result:false};      
    }

  }

  const query_create_invoice = async (data) =>{
    // const url = 'http://127.0.0.1:5001/kogods/us-central1/create_invoice_info'
    const url = live_version? 'https://us-central1-kogods.cloudfunctions.net/create_invoice_info':'http://127.0.0.1:5001/kogods/us-central1/create_invoice_info'
    const requestBody = {
      "amount":data.amount,
      "from":data.from,
      "msg":data.message,
      "number":data.number
    }
    try {
      var response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers': 'Content-Type'
        }
      })
      return response.json();
    } catch (error) {
      return {result:false};      
    }
  }

  const handleClick = (msg)=> {
    console.log('click', msg)
    exist_ = false;
    // check msg.amount
    const amount_ = parseInt(msg.amount);
    const number_ = parseInt(msg.number);

    const valid_sats = false;
    const valid_number = false;
    if( typeof amount_ == 'number' && amount_>=10 ) {
      valid_sats = true;
    }
    if( typeof number_ == 'number' && number_>0 && number_<=10 ) {
      valid_number = true;
    }
    //

    if(!valid_sats) alert('10 사토시 이상 입력해주세요.')
    else if(!valid_number) alert('10개 이하로 기프트콘 개수를 입력해주세요.')
    if(valid_sats && valid_number){
      // call api

      const sum_amount = amount_* number_;
      const data_ = {
        amount:sum_amount,
        message:msg.message,
        from:msg.sender,
        number:number_
      }
      query_create_invoice(data_).then(r=>{
        if(r.result){
          setNumber(number_);
          setAmount(sum_amount)
          setInvoice(r.invoice)
          setHash(r.hash)
        }
      })
    }
  }

  return (
    <section className="relative py-20 lg:pt-48">
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 dark:hidden">
        <img src="/images/gradient.jpg" alt="gradient" />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
        <img src="/images/gradient_dark.jpg" alt="gradient dark" />
      </picture>

      <div className="container">
        <div className="h-full items-center gap-4 lg:grid lg:grid-cols-12">
          <div className="flex h-full flex-col items-center justify-center py-10 lg:col-span-5 lg:items-start lg:py-20">
            <div className="flex">
            <div className="mb-8 flex items-center space-x-3 rounded-3xl border border-jacarta-200 px-5 py-2 dark:border-jacarta-300">
      
              <span className="text-xs font-bold uppercase tracking-wide text-jacarta-500 dark:text-jacarta-100">
                {heroContent.meta[0]}
              </span>
            </div>

            <div className="ml-2 mb-8 flex items-center space-x-3 rounded-3xl border border-jacarta-200 px-5 py-2 dark:border-jacarta-300">
          
              <span className="text-xs font-bold uppercase tracking-wide text-jacarta-500 dark:text-jacarta-100">
                {heroContent.meta[1]}
              </span>
            </div>            
            
            </div>

            <h1 className="mb-6 text-center font-display text-5xl text-jacarta-700 dark:text-white lg:text-left lg:text-6xl">
              {heroContent.title}
            </h1>
            <p className="mb-2 max-w-md text-center text-lg dark:text-jacarta-200 lg:text-left">
              {heroContent.descriptions}
            </p>

            <p className="mb-8 max-w-md text-center text-sm dark:text-jacarta-200 lg:text-left">
            (장시간 보관에 적합하지 않습니다. 소액으로 테스트해주세요.)
            </p>
            <p className="mb-8 max-w-md text-center text-sm dark:text-jacarta-200 lg:text-left">
            {heroContent.description2}
            </p>
                        
          </div>
          {/* End flex-col */}

          {/* <!-- Hero image --> */}
          <div className="col-span-7 lg:ml-[20%] xl:ml-[30%] flex justify-center">
            {invoice != '' ? (
              <div>

              {payStatus ? (
                <WithdrawView hash={hash} invoice={lnurlwInvoice} number={number}></WithdrawView>
              ) : (<QRCodeView invoice={invoice} amount={amount} number={number}></QRCodeView>)}
              </div>

              
            ) : (
              <CreatingInvoice className="" handleClick={handleClick}></CreatingInvoice>
            )}
          </div>
        </div>
      </div>
    </section>
  );

};

export default CreateGift;
